
export default {
	name: 'thousands',
	handler: {
		update: function (element, valueAccessor, allBindingsAccessor) {
			return ko.bindingHandlers.text.update(element, function () {
				var value = +(ko.utils.unwrapObservable(valueAccessor()) || 0);
				var rx = /(\d+)(\d{3})/;
				if (value.toString().indexOf('-') !== -1)
				{
					value = value.toString().slice(1, value.toString().length);
					return String(value).replace(/^\d+/, function (w) {
						while (rx.test(w))
							w = w.replace(rx, '$1 $2');

						return '-' + w;
					});
				}
				else
				{
					return String(value).replace(/^\d+/, function (w) {
						while (rx.test(w))
							w = w.replace(rx, '$1 $2');

						return w;
					});
				}
			});
		}
	}
};
